import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipiDannoFormComponent } from './dialogs/form/form.component';
import { TipiDannoComponent } from './tipi-danno.component';


const routes: Routes = [
  {
    path: '', component: TipiDannoComponent
  },
  {
    path: 'inserisci', component: TipiDannoFormComponent,
    data: { title: 'Inserimento tipi di danno' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipiDannoRoutingModule { }
